import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const STORY_IMG = "/products/brand-story-bg.jpg";

const PILLARS = [
  { n: "01", t: "Discretion", d: "Plain boxes. Unmarked couriers. Quiet billing entries. Your intimacy stays yours." },
  { n: "02", t: "Craft", d: "Every condom is rolled to 0.045mm precision and electronically tested. No exception." },
  { n: "03", t: "Sustainability", d: "FSC-certified plantation latex. Recyclable boxes. Considered every step." },
  { n: "04", t: "Honesty", d: "No exaggerated claims. Just disciplined wellness, presented at its truest." },
];

export default function About() {
  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="about-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 space-y-32">
        <section>
          <div className="grid lg:grid-cols-12 gap-12 items-end">
            <div className="lg:col-span-7 space-y-8">
              <div className="label-eyebrow">The BananaX Manifesto</div>
              <motion.h1
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9 }}
                className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]"
              >
                Intimacy is a <span className="italic text-gradient-gold">ritual</span>.
                <br />Protection should match it.
              </motion.h1>
              <p className="text-mist font-light text-lg leading-relaxed max-w-2xl">
                BananaX was founded on a quiet refusal — that intimate wellness should look,
                feel and arrive like a pharmacy errand. So we re-engineered the experience
                from raw latex to unmarked doorstep. Every detail, deliberate.
              </p>
            </div>
            <div className="lg:col-span-5 aspect-[4/5] product-image-wrap border hairline-gold">
              <img src={STORY_IMG} alt="" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-ink-950/30"></div>
            </div>
          </div>
        </section>

        <section className="grid lg:grid-cols-4 gap-px bg-white/5">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-ink-950 p-10 space-y-4 hover:bg-ink-900 transition-colors"
            >
              <div className="num-display text-3xl text-gold/70">{p.n}</div>
              <h3 className="font-serif text-2xl text-bone">{p.t}</h3>
              <p className="text-mist font-light leading-relaxed text-sm">{p.d}</p>
            </motion.div>
          ))}
        </section>

        <section className="text-center max-w-3xl mx-auto space-y-8">
          <div className="label-eyebrow">A Note from the Founders</div>
          <p className="font-serif text-3xl md:text-4xl leading-tight italic text-bone text-balance">
            &ldquo;We make BananaX for the partner who notices the candle, the playlist, and the box.
            Premium wellness is not a luxury &mdash; it&rsquo;s an act of self-respect.&rdquo;
          </p>
          <p className="label-eyebrow text-mist">— The BananaX Atelier</p>
          <Link to="/shop" className="btn-primary mt-8 inline-flex">Discover the Collection</Link>
        </section>
      </div>
    </div>
  );
}
